// extracted by mini-css-extract-plugin
export default {"createdAt":"generate-pdf-tab_createdAt__cxx07","downloadLinks":"generate-pdf-tab_downloadLinks__YOl-3"};